import React from 'react';
import { ProductInterface } from 'interfaces/product.interface';
import ProductBox from 'components/product/product-box/product-box';
import './product-proposed.scss';
import ProductOffersTitle from 'components/product/product-offer/product-offers-title';

interface ProductProposedProps {
    proposedProducts: ProductInterface[];
}

const ProductProposed: React.FC<ProductProposedProps> = ({ proposedProducts }) => (
    <div className="product-proposed">
        <div className="product-proposed__title">
            <ProductOffersTitle
                productName={`${proposedProducts[0]?.category.name ?? 'Inne'} - najlepsze propozycje`}
                description={''}
                isLarge={true}
            />
        </div>
        <div className="product-proposed__container">
            {proposedProducts.map((product, index) => (
                <ProductBox key={product.id} product={product} loading={index < 2 ? 'eager' : 'lazy'}/>
            ))}
        </div>
    </div>
);

export default ProductProposed;
